import { exitImpersonation } from "@services/auth";

export default function ImpersonationBanner() {
  const isImpersonating = localStorage.getItem("impersonating") === "true";
  if (!isImpersonating) return null;

  const email = localStorage.getItem("impersonating_email") || "unknown user";

  return (
    <div className="bg-amber-400 text-amber-950 px-4 py-2 text-sm font-medium flex items-center justify-between z-50">
      <span>You are viewing as {email}</span>
      <button
        onClick={exitImpersonation}
        className="ml-4 px-3 py-1 bg-amber-800 text-white text-xs font-semibold rounded hover:bg-amber-900 transition-colors"
      >
        Exit Impersonation
      </button>
    </div>
  );
}
